import React, { useState } from 'react';
import './SupportedDevices.css';

function SupportedDevices() {
  const [selectedCategory, setSelectedCategory] = useState('smart-meters');

  const deviceCategories = {
    'smart-meters': {
      title: 'Akıllı Sayaçlar & IoT',
      icon: '⚡',
      devices: [
        {
          name: 'Landis+Gyr E350',
          description: 'Tek fazlı akıllı elektrik sayacı',
          features: ['Modbus TCP', 'WiFi', '3G/4G', 'Gerçek zamanlı izleme'],
          status: 'Tam Destek',
          image: '🔌'
        },
        {
          name: 'Schneider Electric iEM3000',
          description: 'Çok fazlı enerji monitörü',
          features: ['Modbus RTU', 'Ethernet', 'RS485', 'Harmonik analizi'],
          status: 'Tam Destek',
          image: '📊'
        },
        {
          name: 'ABB M2M Gateway',
          description: 'Sayaç veri toplama ünitesi',
          features: ['LoRaWAN', 'NB-IoT', 'WiFi', 'IoT entegrasyonu'],
          status: 'Tam Destek',
          image: '📡'
        },
        {
          name: 'Siemens 7KT1536',
          description: 'Çoklu enerji parametre monitörü',
          features: ['Modbus TCP', 'Ethernet', 'Güç faktörü', 'Reaktif enerji'],
          status: 'Tam Destek',
          image: '⚡'
        }
      ]
    },
    'iot-sensors': {
      title: 'IoT Sensörler & Röleler',
      icon: '🌡️',
      devices: [
        {
          name: 'Shelly EM',
          description: 'Akıllı enerji monitörü',
          features: ['WiFi', 'WebUI', 'API', 'Gerçek zamanlı'],
          status: 'Tam Destek',
          image: '🔋'
        },
        {
          name: 'Sonoff POW R2',
          description: 'Akıllı güç monitörü',
          features: ['WiFi', 'eWeLink', 'Tasmota', 'Uzaktan kontrol'],
          status: 'Tam Destek',
          image: '⚡'
        },
        {
          name: 'Schneider Electric PM8000',
          description: 'Gelişmiş enerji monitörü',
          features: ['Modbus', 'Ethernet', 'Harmonik analizi', 'Alarm sistemi'],
          status: 'Tam Destek',
          image: '📊'
        },
        {
          name: 'Honeywell Tridium JACE',
          description: 'IoT gateway ve kontrol cihazı',
          features: ['BACnet', 'Modbus', 'WebUI', 'Alarm yönetimi'],
          status: 'Tam Destek',
          image: '🔧'
        }
      ]
    },
    'smart-plugs': {
      title: 'Akıllı Prizler',
      icon: '🔌',
      devices: [
        {
          name: 'TP-Link HS110',
          description: 'WiFi akıllı priz',
          features: ['Enerji izleme', 'Zamanlama', 'Uzaktan kontrol'],
          status: 'Tam Destek',
          image: '🔌'
        },
        {
          name: 'Sonoff S31',
          description: 'Zigbee akıllı priz',
          features: ['Zigbee 3.0', 'Enerji izleme', 'OTA güncelleme'],
          status: 'Tam Destek',
          image: '📱'
        },
        {
          name: 'Meross MSS310',
          description: 'HomeKit akıllı priz',
          features: ['HomeKit', 'WiFi', 'Enerji izleme'],
          status: 'Kısmi Destek',
          image: '🍎'
        }
      ]
    },
    'smart-switches': {
      title: 'Akıllı Anahtarlar',
      icon: '🔘',
      devices: [
        {
          name: 'Shelly 1L',
          description: 'WiFi akıllı anahtar',
          features: ['WiFi', 'WebUI', 'API', 'Zamanlama'],
          status: 'Tam Destek',
          image: '🔘'
        },
        {
          name: 'Sonoff Basic',
          description: 'WiFi akıllı anahtar',
          features: ['WiFi', 'eWeLink', 'Tasmota'],
          status: 'Tam Destek',
          image: '⚡'
        },
        {
          name: 'TP-Link HS200',
          description: 'WiFi duvar anahtarı',
          features: ['WiFi', 'TP-Link Kasa', 'IFTTT'],
          status: 'Kısmi Destek',
          image: '🔘'
        }
      ]
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Tam Destek': return '#4CAF50';
      case 'Kısmi Destek': return '#FF9800';
      case 'Test Aşamasında': return '#2196F3';
      default: return '#757575';
    }
  };

  return (
    <div className="supported-devices">
      <div className="devices-header">
        <h1>🌐 IoT Cihaz Yönetimi</h1>
        <p>Bağlı cihazlarınızı görüntüleyin, IoT entegrasyonunu yönetin ve donanım sağlığını izleyin</p>
      </div>

      <div className="devices-content">
        <div className="category-selector">
          {Object.entries(deviceCategories).map(([key, category]) => (
            <button
              key={key}
              className={`category-button ${selectedCategory === key ? 'active' : ''}`}
              onClick={() => setSelectedCategory(key)}
            >
              <span className="category-icon">{category.icon}</span>
              <span className="category-title">{category.title}</span>
            </button>
          ))}
        </div>

        <div className="devices-section">
          <div className="section-header">
            <span className="section-icon">{deviceCategories[selectedCategory].icon}</span>
            <h2>{deviceCategories[selectedCategory].title}</h2>
            <p>Bu kategoride {deviceCategories[selectedCategory].devices.length} cihaz desteklenmektedir</p>
          </div>

          <div className="devices-grid">
            {deviceCategories[selectedCategory].devices.map((device, index) => (
              <div key={index} className="device-card">
                <div className="device-header">
                  <div className="device-icon">{device.image}</div>
                  <div className="device-info">
                    <h3>{device.name}</h3>
                    <p>{device.description}</p>
                  </div>
                  <div 
                    className="device-status"
                    style={{ backgroundColor: getStatusColor(device.status) }}
                  >
                    {device.status}
                  </div>
                </div>
                
                <div className="device-features">
                  <h4>Özellikler:</h4>
                  <div className="features-list">
                    {device.features.map((feature, featureIndex) => (
                      <span key={featureIndex} className="feature-tag">
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="device-actions">
                  <button className="action-button primary">
                    📖 Kurulum Rehberi
                  </button>
                  <button className="action-button secondary">
                    💬 Destek
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="compatibility-info">
          <h3>🔧 Uyumluluk Bilgileri</h3>
          <div className="info-grid">
            <div className="info-card">
              <h4>✅ Tam Destek</h4>
              <p>Tüm özellikler çalışır, resmi dokümantasyon mevcut</p>
            </div>
            <div className="info-card">
              <h4>⚠️ Kısmi Destek</h4>
              <p>Temel özellikler çalışır, bazı gelişmiş özellikler kısıtlı</p>
            </div>
            <div className="info-card">
              <h4>🧪 Test Aşamasında</h4>
              <p>Beta test sürümü, kararlılık garantisi yok</p>
            </div>
          </div>
        </div>

        <div className="request-device">
          <h3>📝 Cihaz Önerisi</h3>
          <p>Cihazınız listede yok mu? Bize önerin ve geliştirme listesine ekleyelim!</p>
          <div className="request-form">
            <input type="text" placeholder="Cihaz adı" className="form-input" />
            <input type="text" placeholder="Üretici" className="form-input" />
            <textarea placeholder="Cihaz özellikleri ve bağlantı detayları" className="form-textarea"></textarea>
            <button className="submit-button">
              📤 Öneriyi Gönder
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SupportedDevices;
